import useMediaQuery from '@mui/material/useMediaQuery'

const MediaQuery = ({ from, to, children }) => {
	const matches = useMediaQuery(`(min-width:${from}px)${to ? ` and (max-width:${to}px)` : ''}`)
	return matches ? children : null
}

export default MediaQuery
